/**
 * An ITelemetryNamespaceLogger implementation to persist telemetry properties
 * for a logger and log events under a single namespace.
 */ export class NamespaceLoggerAdapter {
    get NamespaceLogger() {
        return this;
    }
    get PersistedProperties() {
        return this;
    }
    addPersistedProperties(properties) {
        this.persistedProperties = {
            ...this.persistedProperties,
            ...properties
        };
    }
    send(event) {
        this.sendWithNamespace(event, this.namespace);
    }
    sendWithNamespace(event, namespace) {
        this.logger?.sendWithNamespace({
            ...this.persistedProperties,
            ...event
        }, namespace);
    }
    dispose() {
        // On dispose, set the logger to null
        // This acts as a signal not to send any more logs (e.g., to avoid logging
        // errors after an iframe has already been disposed).
        // It may also help avoid memory leaks (though we weren't observing any such issues in this flow anyway).
        this.logger = null;
    }
    constructor(namespace, baseLogger, persistedProperties){
        this.namespace = namespace;
        if (baseLogger instanceof NamespaceLoggerAdapter) {
            const combinedProperties = {
                ...baseLogger.persistedProperties,
                ...persistedProperties
            };
            this.logger = baseLogger.logger;
            this.persistedProperties = combinedProperties;
        } else {
            this.logger = baseLogger;
            this.persistedProperties = persistedProperties;
        }
    }
}
